import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { convertLegacyPageExtension } from '@backstage/core-compat-api';
import { GauthPluginPage } from '@cariad-dxp/gauth-plugin';

// @cariad-dxp/gauth-plugin has no `./alpha` export yet. GauthPluginPage is a
// legacy routable extension that fails to render unless its mount point is
// registered, so it is converted instead of wrapped. The package entry is
// small; the routable extension still loads the page on first visit.
const gauthPage = convertLegacyPageExtension(GauthPluginPage, {
  name: 'gauth',
  path: '/gauth',
});

export const gauthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [gauthPage],
});
